const normalizeText = (value = "") =>
  String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

export const normalizeOperationalStatus = (estado = "") =>
  normalizeText(estado)
    .replace(/\s+/g, "_")
    .replace(/^_+|_+$/g, "");

const redVisual = {
  chipColor: "error",
  background: "rgba(220, 38, 38, 0.07)",
  border: "#dc2626",
  textColor: "#991b1b",
};

const greenVisual = {
  chipColor: "success",
  background: "rgba(22, 163, 74, 0.08)",
  border: "#16a34a",
  textColor: "#166534",
};

const yellowVisual = {
  chipColor: "warning",
  background: "rgba(234, 179, 8, 0.10)",
  border: "#eab308",
  textColor: "#854d0e",
};

const grayVisual = {
  chipColor: "default",
  background: "rgba(100, 116, 139, 0.06)",
  border: "#94a3b8",
  textColor: "#475569",
};

const operationalMarkerColors = {
  waiting: "#eab308",
  preparation: "#f59e0b",
  deployed: "#16a34a",
  closed: "#dc2626",
  cancelled: "#991b1b",
  unknown: "#64748b",
};

const operationalStates = {
  finalizada: { label: "Finalizada", ...redVisual, markerColor: operationalMarkerColors.closed },
  finalizado: { label: "Finalizado", ...redVisual, markerColor: operationalMarkerColors.closed },
  cerrada: { label: "Cerrada", ...redVisual, markerColor: operationalMarkerColors.closed },
  cerrado: { label: "Cerrado", ...redVisual, markerColor: operationalMarkerColors.closed },
  cancelada: { label: "Cancelada", ...redVisual, markerColor: operationalMarkerColors.cancelled },
  cancelado: { label: "Cancelado", ...redVisual, markerColor: operationalMarkerColors.cancelled },
  vencida: { label: "Vencida", ...redVisual, markerColor: operationalMarkerColors.closed },
  vencido: { label: "Vencido", ...redVisual, markerColor: operationalMarkerColors.closed },
  desplegada: { label: "Desplegada", ...greenVisual, markerColor: operationalMarkerColors.deployed },
  desplegado: { label: "Desplegado", ...greenVisual, markerColor: operationalMarkerColors.deployed },
  activa: { label: "Activa", ...greenVisual, markerColor: operationalMarkerColors.deployed },
  activo: { label: "Activo", ...greenVisual, markerColor: operationalMarkerColors.deployed },
  hoy: { label: "Hoy", ...greenVisual, markerColor: operationalMarkerColors.deployed },
  en_preparacion: {
    label: "En preparación",
    ...yellowVisual,
    markerColor: operationalMarkerColors.preparation,
  },
  preparacion: {
    label: "En preparación",
    ...yellowVisual,
    markerColor: operationalMarkerColors.preparation,
  },
  en_espera: { label: "En espera", ...yellowVisual, markerColor: operationalMarkerColors.waiting },
  espera: { label: "En espera", ...yellowVisual, markerColor: operationalMarkerColors.waiting },
  futura: { label: "Futura", ...yellowVisual, markerColor: operationalMarkerColors.waiting },
  futuro: { label: "Futuro", ...yellowVisual, markerColor: operationalMarkerColors.waiting },
  sin_estado: { label: "Sin estado", ...grayVisual, markerColor: operationalMarkerColors.unknown },
};

export const operationalTransitions = {
  en_espera: ["en_preparacion", "cancelado"],
  en_preparacion: ["desplegado", "cancelado"],
  desplegado: ["cerrado", "cancelado"],
  cerrado: [],
  cancelado: [],
};

export const canonicalOperationalStateOptions = [
  { value: "en_espera", label: "En espera" },
  { value: "en_preparacion", label: "En preparación" },
  { value: "desplegado", label: "Desplegado" },
  { value: "cerrado", label: "Cerrado" },
  { value: "cancelado", label: "Cancelado" },
];

export const getEstadoOperativoVisual = (estado = "") => {
  const normalized = normalizeOperationalStatus(estado) || "sin_estado";

  return (
    operationalStates[normalized] || {
      label: estado || "Sin estado",
      ...grayVisual,
      markerColor: operationalMarkerColors.unknown,
    }
  );
};

export const getAllowedOperationalTransitions = (estado = "") =>
  operationalTransitions[normalizeOperationalStatus(estado)] || [];

export const isTerminalOperationalStatus = (estado = "") =>
  ["cerrado", "cancelado"].includes(normalizeOperationalStatus(estado));

export const getOperationalOriginLabel = (origen = "") => {
  const normalized = normalizeOperationalStatus(origen);
  const labels = {
    manual: "Cambio manual",
    sistema: "Sistema",
    sincronizacion: "Sincronización",
    legacy: "Estado histórico",
    automatico: "Cálculo automático",
  };

  return labels[normalized] || origen || "Sin origen";
};
